import { Grid } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { ColorDescription } from 'app/components/ColorDescription';
import { translations } from 'locales/i18n';
import { Colors } from 'utils/colors';

export const AvailableColorsDescription = () => {
  const { t } = useTranslation();
  return (
    <Grid item>
      <ColorDescription
        color={Colors.availableColor}
        colorDescription={t(translations.pages.leihbar.product.availability.availableDescription())}
      />
      <ColorDescription
        color={Colors.partiallyAvailableColor}
        colorDescription={t(
          translations.pages.leihbar.product.availability.partiallyAvailableDescription()
        )}
      />
    </Grid>
  );
};
